var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3, _linearGradient4, _path4, _linearGradient5, _path5, _linearGradient6, _path6, _linearGradient7, _path7, _linearGradient8, _path8;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCategory2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q81dqehHWrgyhAQSBh2D_a",
    x1: 12.446,
    x2: 15.554,
    y1: 5.185,
    y2: 22.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#199ae0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0782d8"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q81dqehHWrgyhAQSBh2D_a)",
    d: "M22,20V8c0-1.105-0.895-2-2-2H8C6.895,6,6,6.895,6,8v12c0,1.105,0.895,2,2,2h12 C21.105,22,22,21.105,22,20z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q81dqehHWrgyhAQSBh2D_b",
    x1: 32.446,
    x2: 35.554,
    y1: 25.185,
    y2: 42.815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21ad64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#088242"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q81dqehHWrgyhAQSBh2D_b)",
    d: "M42,28v12c0,1.1-0.9,2-2,2H28c-1.1,0-2-0.9-2-2V28c0-1.1,0.9-2,2-2h12C41.1,26,42,26.9,42,28 z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q81dqehHWrgyhAQSBh2D_c",
    x1: 12.412,
    x2: 15.684,
    y1: 24.992,
    y2: 43.548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a235d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#a033d1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.702,
    stopColor: "#982cc9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.915,
    stopColor: "#8b21bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#831bb3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q81dqehHWrgyhAQSBh2D_c)",
    d: "M20,26H8c-1.105,0-2,0.895-2,2v12c0,1.105,0.895,2,2,2h12c1.105,0,2-0.895,2-2V28 C22,26.895,21.105,26,20,26z"
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q81dqehHWrgyhAQSBh2D_d",
    x1: 32.637,
    x2: 36.902,
    y1: 6.272,
    y2: 30.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#f44f78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#e4305d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#d81b4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d41343"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q81dqehHWrgyhAQSBh2D_d)",
    d: "M40,6H28c-1.105,0-2,0.895-2,2v12c0,1.105,0.895,2,2,2h12c1.105,0,2-0.895,2-2V8 C42,6.895,41.105,6,40,6L40,6z"
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q81dqehHWrgyhAQSBh2D_e",
    x1: 32.72,
    x2: 34.294,
    y1: 9.741,
    y2: 18.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec60f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q81dqehHWrgyhAQSBh2D_e)",
    d: "M38.852,16.476l-4-6.5c-0.363-0.592-1.34-0.592-1.703,0l-4,6.5 c-0.19,0.309-0.198,0.695-0.021,1.012S29.638,18,30,18h8c0.362,0,0.696-0.196,0.873-0.512S39.042,16.785,38.852,16.476z"
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q81dqehHWrgyhAQSBh2D_f",
    x1: 13.142,
    x2: 14.858,
    y1: 29.136,
    y2: 38.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec60f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q81dqehHWrgyhAQSBh2D_f)",
    d: "M18.707,33.293l-4-4c-0.391-0.391-1.023-0.391-1.414,0l-4,4 c-0.391,0.391-0.391,1.023,0,1.414l4,4C13.488,38.902,13.744,39,14,39s0.512-0.098,0.707-0.293l4-4 C19.098,34.316,19.098,33.684,18.707,33.293z"
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q81dqehHWrgyhAQSBh2D_g",
    x1: 33.311,
    x2: 35.097,
    y1: 29.147,
    y2: 39.275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda1c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q81dqehHWrgyhAQSBh2D_g)",
    d: "M39.105,32.745c-0.115-0.354-0.418-0.614-0.785-0.675l-2.338-0.391l-1.092-2.134 c-0.344-0.668-1.438-0.668-1.781,0l-1.092,2.134l-2.338,0.391c-0.367,0.062-0.67,0.322-0.785,0.675 c-0.116,0.354-0.025,0.743,0.234,1.009l1.671,1.714l-0.357,2.384c-0.055,0.37,0.101,0.74,0.404,0.959 c0.304,0.218,0.704,0.25,1.037,0.081L34,37.819l2.116,1.073C36.259,38.964,36.414,39,36.568,39c0.206,0,0.411-0.064,0.585-0.189 c0.304-0.219,0.459-0.589,0.404-0.959L37.2,35.468l1.671-1.714C39.131,33.487,39.222,33.099,39.105,32.745z"
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "q81dqehHWrgyhAQSBh2D_h",
    x1: 13.142,
    x2: 14.858,
    y1: 9.136,
    y2: 18.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec60f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb705"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q81dqehHWrgyhAQSBh2D_h)",
    d: "M17.964,11.134l-3.464-2c-0.309-0.179-0.691-0.179-1,0l-3.464,2 c-0.31,0.179-0.5,0.509-0.5,0.866v4c0,0.357,0.19,0.688,0.5,0.866l3.464,2C13.654,18.955,13.827,19,14,19s0.346-0.044,0.5-0.134 l3.464-2c0.31-0.179,0.5-0.509,0.5-0.866v-4C18.464,11.643,18.273,11.313,17.964,11.134z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory2);
export default __webpack_public_path__ + "static/media/category2.0f8131ce.svg";
export { ForwardRef as ReactComponent };